/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {NewsletterDTO} from '../model/newsletterDTO';
import {NewsletterNodeDTO} from '../model/newsletterNodeDTO';
import {NewsletterTenant} from '../model/newsletterTenant';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorNewsletterService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Supprimer une newsletter
     * Cette requête permet de supprimer une newsletter.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;Le champ &lt;b&gt;id&lt;/b&gt; est l&#39;identifiant de la newsletter (id ou uuid).&lt;br&gt;En cas de succès, la réponse renvoie le code &lt;b&gt;204 (NO_CONTENT)&lt;/b&gt;.&lt;br&gt;&lt;b&gt; Note :&lt;/b&gt; Par défault, le paramètre &lt;b&gt;isUuid&lt;/b&gt; est à &lt;b&gt;true&lt;/b&gt;, donc l&#39;identifiant qu&#39;il faut est l&#39;&lt;b&gt;uuid&lt;b&gt;. Mais si jamais on veut supprimer une newsletter par son identifiant, il faut mettre le paramètre &lt;b&gt;isUuid&lt;/b&gt; à &lt;b&gt;false&lt;/b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param isUuid isUuid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteNewsletterUsingDELETE(xDataStoreID: string, id: string, isUuid: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteNewsletterUsingDELETE(xDataStoreID: string, id: string, isUuid: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteNewsletterUsingDELETE(xDataStoreID: string, id: string, isUuid: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteNewsletterUsingDELETE(xDataStoreID: string, id: string, isUuid: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteNewsletterUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteNewsletterUsingDELETE.');
        }

        if (isUuid === null || isUuid === undefined) {
            throw new Error('Required parameter isUuid was null or undefined when calling deleteNewsletterUsingDELETE.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isUuid !== undefined && isUuid !== null) {
            queryParameters = queryParameters.set('isUuid', <any> isUuid);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/newsletters/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les identifiants et les titres des newsletters d&#39;un tenant
     * Cette requête permet de lister les identifiants et les titres des newsletters d&#39;un tenant.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;La réponse de cette requête est une liste de mapping entre chaque identifiant de newsletter et son titre du tenant concerné.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllNewslettersIdLabelUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public getAllNewslettersIdLabelUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public getAllNewslettersIdLabelUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public getAllNewslettersIdLabelUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllNewslettersIdLabelUsingGET.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getAllNewslettersIdLabelUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/newsletters/items`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une newsletter par son identifiant
     * Cette requête permet d&#39;obtenir une newsletter par son identifiant.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;Le champ &lt;b&gt;id&lt;/b&gt; est l&#39;identifiant de la newsletter.&lt;br&gt;En cas de succès, la réponse contient une newsletter et renvoie le code &lt;b&gt;200 (OK)&lt;/b&gt;.&lt;br&gt;En cas d&#39;échec, la réponse renvoie le code &lt;b&gt;404 (Not Found)&lt;/b&gt; si la newsletter n&#39;existe pas.&lt;br&gt;&lt;b&gt; Note :&lt;/b&gt; Chaque newletter a un identifiant id et un uuid. Pour cette requête, l&#39;identifiant qu&#39;il faut est l&#39;&lt;b&gt;id&lt;b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param id id
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewsletterUsingGET1(xDataStoreID: string, X_LANG: string, id: string, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterDTO>;
    public getNewsletterUsingGET1(xDataStoreID: string, X_LANG: string, id: string, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterDTO>>;
    public getNewsletterUsingGET1(xDataStoreID: string, X_LANG: string, id: string, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterDTO>>;
    public getNewsletterUsingGET1(xDataStoreID: string, X_LANG: string, id: string, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getNewsletterUsingGET1.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getNewsletterUsingGET1.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getNewsletterUsingGET1.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NewsletterDTO>(`${this.basePath}/api/newsletters/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les newsletters par tenant
     * Cette requête permet de lister chaque tenant (datastore) avec ses newsletters.
     * @param X_LANG X-LANG
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewslettersAllTenantUsingGET(X_LANG: string, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: NewsletterTenant; }>;
    public getNewslettersAllTenantUsingGET(X_LANG: string, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: NewsletterTenant; }>>;
    public getNewslettersAllTenantUsingGET(X_LANG: string, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: NewsletterTenant; }>>;
    public getNewslettersAllTenantUsingGET(X_LANG: string, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getNewslettersAllTenantUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: NewsletterTenant; }>(`${this.basePath}/api/newsletters/alltenant`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une newsletter par uuid
     * Cette requête permet d&#39;obtenir une newsletter par son uuid.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;Le champ &lt;b&gt;uuid&lt;/b&gt; est l&#39;uuid de la newsletter.&lt;br&gt;En cas de succès, la réponse contient une newsletter et renvoie le code &lt;b&gt;200 (OK)&lt;/b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param uuid uuid
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewslettersByUuidUsingGET(xDataStoreID: string, X_LANG: string, uuid: string, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterNodeDTO>;
    public getNewslettersByUuidUsingGET(xDataStoreID: string, X_LANG: string, uuid: string, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterNodeDTO>>;
    public getNewslettersByUuidUsingGET(xDataStoreID: string, X_LANG: string, uuid: string, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterNodeDTO>>;
    public getNewslettersByUuidUsingGET(xDataStoreID: string, X_LANG: string, uuid: string, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getNewslettersByUuidUsingGET.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getNewslettersByUuidUsingGET.');
        }

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling getNewslettersByUuidUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }
        if (uuid !== undefined && uuid !== null) {
            queryParameters = queryParameters.set('uuid', <any> uuid);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NewsletterNodeDTO>(`${this.basePath}/api/newsletters/uuid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les newsletters
     * Cette requête permet de lister les newsletters.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;Le champ &lt;b&gt;idPart&lt;/b&gt; est le code du partenaire.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Si le champ &lt;b&gt;idPart&lt;/b&gt; est vide, alors la requête va renvoyer toutes les newsletters.&lt;br&gt;En cas de succès, la réponse contient une liste de newsletters et renvoie le code &lt;b&gt;200 (OK)&lt;/b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param X_LANG2 X-LANG
     * @param idPart idPart
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewslettersUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, idPart?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NewsletterDTO>>;
    public getNewslettersUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, idPart?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewsletterDTO>>>;
    public getNewslettersUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, idPart?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewsletterDTO>>>;
    public getNewslettersUsingGET(xDataStoreID: string, X_LANG: string, X_LANG2?: string, idPart?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getNewslettersUsingGET.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getNewslettersUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }
        if (idPart !== undefined && idPart !== null) {
            queryParameters = queryParameters.set('idPart', <any> idPart);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NewsletterDTO>>(`${this.basePath}/api/newsletters`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une newsletter
     * Cette requête permet de mettre à jour une newsletter.&lt;br&gt;Le champ &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code du datastore.&lt;br&gt;Le champ &lt;b&gt;newsletters&lt;/b&gt; est liste de newsletters.&lt;br&gt;En cas de succès, le code &lt;b&gt;200 (OK)&lt;/b&gt; est renvoyé.&lt;br&gt;En cas d&#39;erreur, le code &lt;b&gt;400 (Bad Request)&lt;/b&gt; est renvoyé si le JSON envoyé est invalide.&lt;br&gt;En cas d&#39;erreur, le code &lt;b&gt;500 (Internal Server Error)&lt;/b&gt; est renvoyé si la mise à jour de la newsletter a échouée.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param newsletters newsletters
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNewsletterUsingPUT(xDataStoreID: string, X_LANG: string, newsletters: Array<NewsletterDTO>, isNew: boolean, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterDTO>;
    public updateNewsletterUsingPUT(xDataStoreID: string, X_LANG: string, newsletters: Array<NewsletterDTO>, isNew: boolean, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterDTO>>;
    public updateNewsletterUsingPUT(xDataStoreID: string, X_LANG: string, newsletters: Array<NewsletterDTO>, isNew: boolean, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterDTO>>;
    public updateNewsletterUsingPUT(xDataStoreID: string, X_LANG: string, newsletters: Array<NewsletterDTO>, isNew: boolean, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateNewsletterUsingPUT.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling updateNewsletterUsingPUT.');
        }

        if (newsletters === null || newsletters === undefined) {
            throw new Error('Required parameter newsletters was null or undefined when calling updateNewsletterUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }
        if (isNew !== undefined && isNew !== null) {
            queryParameters = queryParameters.set('isNew', <any> isNew);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NewsletterDTO>(`${this.basePath}/api/newsletters`,
            newsletters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour les affiliés destinataires d'un abonnement
     * Cette requête permet à un Tenant Admin de désigner les affiliés destinataires (accès en lecture seule) d'un abonnement. Réservée au Tenant Admin du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param id id
     * @param affectedPartners affectedPartners
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNewsletterPartnersUsingPUT(xDataStoreID: string, X_LANG: string, id: string, affectedPartners: Array<string>, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterDTO>;
    public updateNewsletterPartnersUsingPUT(xDataStoreID: string, X_LANG: string, id: string, affectedPartners: Array<string>, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterDTO>>;
    public updateNewsletterPartnersUsingPUT(xDataStoreID: string, X_LANG: string, id: string, affectedPartners: Array<string>, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterDTO>>;
    public updateNewsletterPartnersUsingPUT(xDataStoreID: string, X_LANG: string, id: string, affectedPartners: Array<string>, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateNewsletterPartnersUsingPUT.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling updateNewsletterPartnersUsingPUT.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateNewsletterPartnersUsingPUT.');
        }

        if (affectedPartners === null || affectedPartners === undefined) {
            throw new Error('Required parameter affectedPartners was null or undefined when calling updateNewsletterPartnersUsingPUT.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NewsletterDTO>(`${this.basePath}/api/newsletters/${encodeURIComponent(String(id))}/partners`,
            affectedPartners,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dupliquer un abonnement
     * Cette requête permet à un affilié destinataire de dupliquer un abonnement partagé dans son propre périmètre. La copie a un nouveau propriétaire (l'affilié demandeur) et sa liste de partage est réinitialisée.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param id id
     * @param X_LANG2 X-LANG
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateNewsletterUsingPOST(xDataStoreID: string, X_LANG: string, X_PARTNER_ID: string, id: string, X_LANG2?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterDTO>;
    public duplicateNewsletterUsingPOST(xDataStoreID: string, X_LANG: string, X_PARTNER_ID: string, id: string, X_LANG2?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterDTO>>;
    public duplicateNewsletterUsingPOST(xDataStoreID: string, X_LANG: string, X_PARTNER_ID: string, id: string, X_LANG2?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterDTO>>;
    public duplicateNewsletterUsingPOST(xDataStoreID: string, X_LANG: string, X_PARTNER_ID: string, id: string, X_LANG2?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling duplicateNewsletterUsingPOST.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling duplicateNewsletterUsingPOST.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling duplicateNewsletterUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateNewsletterUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_LANG2 !== undefined && X_LANG2 !== null) {
            queryParameters = queryParameters.set('X-LANG', <any> X_LANG2);
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any> X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<NewsletterDTO>(`${this.basePath}/api/newsletters/${encodeURIComponent(String(id))}:duplicate`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    // ============ EXPORT/IMPORT METHODS ============

    /**
     * Exporter une newsletter au format JSON
     * Cette requête permet d'exporter une newsletter au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportNewsletterJson(xDataStoreID: string, id: string, lang?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportNewsletterJson(xDataStoreID: string, id: string, lang?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportNewsletterJson(xDataStoreID: string, id: string, lang?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportNewsletterJson(xDataStoreID: string, id: string, lang?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportNewsletterJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportNewsletterJson.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/newsletters/export/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs newsletters au format ZIP
     * Cette requête permet d'exporter plusieurs newsletters dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportNewslettersZip(xDataStoreID: string, ids: string[], lang?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportNewslettersZip(xDataStoreID: string, ids: string[], lang?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportNewslettersZip(xDataStoreID: string, ids: string[], lang?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportNewslettersZip(xDataStoreID: string, ids: string[], lang?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportNewslettersZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportNewslettersZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/newsletters/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer une newsletter depuis JSON
     * Cette requête permet d'importer une newsletter depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importNewsletterJson(xDataStoreID: string, body: string, lang?: string, observe?: 'body', reportProgress?: boolean): Observable<NewsletterDTO>;
    public importNewsletterJson(xDataStoreID: string, body: string, lang?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NewsletterDTO>>;
    public importNewsletterJson(xDataStoreID: string, body: string, lang?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NewsletterDTO>>;
    public importNewsletterJson(xDataStoreID: string, body: string, lang?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importNewsletterJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importNewsletterJson.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<NewsletterDTO>('post',`${this.basePath}/api/newsletters/import/json`,
            {
                params: queryParameters,
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs newsletters depuis ZIP
     * Cette requête permet d'importer plusieurs newsletters depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importNewslettersZip(xDataStoreID: string, file: Blob, lang?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NewsletterDTO>>;
    public importNewslettersZip(xDataStoreID: string, file: Blob, lang?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewsletterDTO>>>;
    public importNewslettersZip(xDataStoreID: string, file: Blob, lang?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewsletterDTO>>>;
    public importNewslettersZip(xDataStoreID: string, file: Blob, lang?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importNewslettersZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importNewslettersZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<NewsletterDTO>>('post',`${this.basePath}/api/newsletters/import/zip`,
            {
                params: queryParameters,
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
